@if (isJournalEntryLoaded) {
  <div>
    @if (dataSource?.data[0].manualEntry) {
      <div class="layout-row layout-align-end container m-b-20">
        <button
          mat-raised-button
          color="primary"
          (click)="revertTransaction()"
          *LOSxHasPermission="'REVERSE_JOURNALENTRY'"
          [disabled]="dataSource?.data[0].reversed"
        >
          @if (!dataSource.data[0].reversed) {
            <span>
              <fa-icon icon="undo" class="m-r-10"></fa-icon>{{ 'labels.buttons.Revert Transaction' | translate }}
            </span>
          }
          @if (dataSource.data[0].reversed) {
            <span>{{ 'labels.buttons.Transaction Reverted' | translate }}</span>
          }
        </button>
      </div>
    }
    @if (isViewTransaction()) {
      <div class="container m-b-20">
        @if (dataSource) {
          <mat-card class="mat-elevation-z8" ngClass="{{ journalEntryColor() }}">
            <mat-card-content>
              <div class="layout-row-wrap">
                <div class="flex-25 header">
                  {{ 'labels.inputs.Office' | translate }}
                </div>
                <div class="flex-25">
                  {{ dataSource.data[0].officeName }}
                </div>
                <div class="flex-25 header">
                  {{ 'labels.inputs.Transaction Date' | translate }}
                </div>
                <div class="flex-25">
                  {{ dataSource.data[0].transactionDate | dateFormat }}
                </div>
                <div class="flex-25 header">
                  {{ 'labels.inputs.Created By' | translate }}
                </div>
                <div class="flex-25">
                  {{ dataSource.data[0].createdByUserName }}
                </div>
                <div class="flex-25 header">
                  {{ 'labels.inputs.Submitted on' | translate }}
                </div>
                <div class="flex-25">
                  {{ dataSource.data[0].submittedOnDate | datetimeFormat }}
                </div>
                <div class="flex-25 header">
                  {{ 'labels.inputs.Manual Journal Entry' | translate }}
                </div>
                <div class="flex-25">
                  {{ dataSource.data[0].manualEntry | yesNo }}
                </div>
                @if (dataSource.data[0].externalAssetOwner) {
                  <div class="flex-25 header">
                    {{ 'labels.inputs.External Asset Owner' | translate }}
                  </div>
                }
                @if (dataSource.data[0].externalAssetOwner) {
                  <div class="flex-25">
                    {{ dataSource.data[0].externalAssetOwner }}
                  </div>
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
    <div class="mat-elevation-z8 container layout-align-center layout-row-wrap">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="id">
          <th mat-header-cell class="center" *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Entry ID' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.id }}</td>
        </ng-container>
        <ng-container matColumnDef="glAccountType">
          <th mat-header-cell class="center" *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Type' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.glAccountType.value }}</td>
        </ng-container>
        <ng-container matColumnDef="glAccountCode">
          <th mat-header-cell class="center" *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Account Code' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.glAccountCode }}</td>
        </ng-container>
        <ng-container matColumnDef="glAccountName">
          <th mat-header-cell class="center" *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Account Name' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.glAccountName }}</td>
        </ng-container>
        <ng-container matColumnDef="debit">
          <th mat-header-cell class="center" *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Debit' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">
            @if (transaction.entryType.value === 'DEBIT') {
              <span>
                {{ transaction.currency.displaySymbol || transaction.currency.code }}
                {{ transaction.amount | formatNumber }}
              </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="credit">
          <th mat-header-cell class="center" *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Credit' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">
            @if (transaction.entryType.value === 'CREDIT') {
              <span>
                {{ transaction.currency.displaySymbol || transaction.currency.code }}
                {{ transaction.amount | formatNumber }}
              </span>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="viewJournalEntry(row)"
          class="select-row"
        ></tr>
      </table>
      <div class="layout-row layout-align-center m-t-15 m-b-15 gap-5px layout-xs-column">
        <button type="button" color="primary" mat-raised-button (click)="goBack()">
          {{ 'labels.buttons.Back' | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (!isJournalEntryLoaded) {
  <div class="container m-b-20">
    <div class="alert">
      <div class="message">
        <i class="fa fa-exclamation-circle alert-check"></i>
        {{ 'labels.text.No data found' | translate }}
      </div>
    </div>
    <div class="layout-row layout-align-center m-t-15 m-b-15 gap-5px layout-xs-column">
      <button type="button" color="primary" mat-raised-button (click)="goBack()">
        {{ 'labels.buttons.Back' | translate }}
      </button>
    </div>
  </div>
}
